import React, { Component } from "react";

class Nyhetsbrev extends Component {
  render() {
    return (
      <div className="col-xl-3 col-md-6 col-lg-4">
        <div className="card mb-3 bg-dark">
          {/* <img className="card-img-top" src="./img/00.png" /> */}

          <div className="card-body">
            {/* <h4 className="card-title text-light">Smeden i Sund</h4> */}
            {/* <h6 className="card-subtitle mt-2 mb-3 text-light">Bli oppdatert om flere produkter?</h6> */}
            <div className="card-text mb-2 bg-dark text-light ">
              {/* <a className="btn btn-secondary btn-block" href="https://smedenisund.no/nyhetsbrev">
                Nyhetsbrev
              </a> */}

              <a className="btn mt-4 btn-primary text-light btn-block" href="https://www.facebook.com/SmedeniSund">
                Smeden i Sund på Facebook
              </a>

              <a className="btn mt-4 btn-dark text-secondary btn-block" href="https://isakgjertsen.com">
                Web-produksjon: <br /> Isak Gjertsen
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Nyhetsbrev;
